/**
 * Serialize the focused audit log row for "view more on this log".
 * @param {object} context mounted page context
 * @return {object} public audit log context
 */
export function serializeAuditLogsContext(context) {
	const route = String(context.route || '').toLowerCase();
	const onMaintenance = route === '/maintenance';
	const logId = context.log_id ?? context.logId;
	const logName = context.log_name ?? context.logName;
	const hasLog = onMaintenance && typeof logId === 'string' && Boolean(logId);
	return {
		log_id: hasLog ? logId : null,
		log_name: hasLog && typeof logName === 'string' && logName
			? logName
			: null,
	};
}
